export default {
  CLOSE: "Schließen",
  NEXT: "Weiter",
  PREV: "Zurück",
  MODAL: "Sie können diesen modalen Inhalt mit der ESC-Taste schließen",
  ERROR: "Etwas ist schief gelaufen, bitte versuchen Sie es später noch einmal",
  IMAGE_ERROR: "Bild nicht gefunden",
  ELEMENT_NOT_FOUND: "HTML-Element nicht gefunden",
  AJAX_NOT_FOUND: "Fehler beim Laden von AJAX: Nicht gefunden",
  AJAX_FORBIDDEN: "Fehler beim Laden von AJAX: Verboten",
  IFRAME_ERROR: "Fehler beim Laden der Seite",
  TOGGLE_ZOOM: "Zoomstufe umschalten",
  TOGGLE_THUMBS: "Miniaturansichten umschalten",
  TOGGLE_SLIDESHOW: "Diashow wechseln",
  TOGGLE_FULLSCREEN: "Vollbildmodus umschalten",
  DOWNLOAD: "Herunterladen",
};
